RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    //
    // BreakoutBase
    //

    const MetricBreakoutViewBase = RivalIQ.views.LayoutView.mixin({
        className: 'metric-summary',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            chart: '.x-chart-region',
            chartLegend: '.x-chart-legend-region'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;

            const metric = me.dashboardModel.metric;
            const information = metric.getInformation();

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        loadData: function () {
            const me = this;

            const metricDefinition = me.dashboardModel.metric;
            const submetric = me.dashboardModel.submetric;
            const chartMetric = me.dashboardModel.chart;

            const metrics = [metricDefinition];
            if (submetric) {
                metrics.push(submetric);
            }

            if (chartMetric) {
                metrics.push(chartMetric);
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.first();
                    if (submetric) {
                        me.submetric = collection.at(1);
                    }

                    if (chartMetric) {
                        me.chartMetric = collection.last();
                    }
                });
        },

        onBeforeRender: function () {

            const me = this;

            if (me.dashboardModel.chart) {
                me.showChart();
            }
        },

        showChart: _.noop,

        serializeData: function () {
            const me = this;

            const data = {
                metric: {
                    name: me.dashboardModel.getTitle() || me.model.getName(),
                    value: me.model.getValue(),
                    unabbreviatedValue: me.model.getValue({
                        expand: true
                    })
                },
                submetric: null,
                hideMetric: Boolean(me.dashboardModel.hideMetric)
            };

            if (me.submetric) {
                data.submetric = {
                    name: me.submetric.getName(),
                    value: me.submetric.getValue()
                };
            }

            return data;
        }

    });

    const MetricBreakoutWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        processProps: function (props) {
            const me = this;

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        }
    });


    //
    // PieChartBreakout
    //

    const MetricPieChartBreakoutView = MetricBreakoutViewBase.extend({
        template: '#widgetMetricBreakoutTemplate',

        showChart: function () {
            const me = this;
            me.showPieChart();
            me.showLegend();
        },

        showLegend: function () {
            const me = this;

            const legend = new App.views.SummaryItems({
                collection: me.chartMetric.get('submetrics')
            });

            me.chartLegend.show(legend);
        },

        showPieChart: function () {

            const me = this;

            const PieChart = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.METRIC_PIE_CHART);

            const pieChartWidget = new PieChart(me.dashboardModel, {
                props: _.create(me.dashboardModel.attributes, {
                    height: 150
                }),
                metric: me.dashboardModel.chart
            });

            me.chart.showWidget(pieChartWidget);
        },

        onRender: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover();
        }
    });

    const MetricPieChartBreakoutWidget = MetricBreakoutWidget.extend({
        view: MetricPieChartBreakoutView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT, MetricPieChartBreakoutWidget);

    function getMetricMax(metrics) {
        return metrics.reduce(function (max, metric) {
            return Math.max(max, Number(metric.getValue({
                format: false
            })));
        }, 0);
    }

    function getBarData(metrics, divisor, getOverrides) {
        const isDivisorValid = (_.isFinite(divisor) && divisor !== 0);

        if (!getOverrides) {
            getOverrides = _.noop;
        }

        return metrics.map(function (metric) {
            const value = parseFloat(metric.getValue({
                format: false
            }));
            const width = (isDivisorValid ? value / divisor : (value > 0 ? 1 : 0)) * 100;
            return _.extend({
                barClassName: metric.get('className'),
                percentWidth: Math.floor(width),
                title: metric.getName(),
                value: metric.getValue()
            }, getOverrides(metric));
        });
    }

    //
    // BarChartBreakout
    //

    const MetricBarChartBreakoutView = MetricBreakoutViewBase.extend({
        template: '#widgetMetricPercentageTemplate',

        getDivisor: function () {
            const me = this;

            if (me.dashboardModel.useMax) {
                return getMetricMax(me.chartMetric.get('submetrics'));
            } else {
                return Number(me.model.getValue({
                    format: false
                }));
            }
        },

        getBarData: function () {
            const me = this;
            const metrics = me.chartMetric.get('submetrics');
            return getBarData(metrics, me.getDivisor());
        },

        showChart: function () {
            const me = this;

            const percentBars = new App.views.ProgressBars({
                collection: new Backbone.Collection(me.getBarData())
            });

            me.chart.show(percentBars);
        }
    });


    const MetricBarChartBreakoutWidget = MetricBreakoutWidget.extend({
        view: MetricBarChartBreakoutView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT, MetricBarChartBreakoutWidget);

    widgets.MetricProgressBarView = RivalIQ.views.LayoutView.mixin({
        template: '#widgetMetricProgressBarTemplate',
        className: 'metric-summary metric-progress-bar',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            chart: '.x-chart-region'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;
            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: {
                        title: me.getProp('title'),
                        content: me.getProp('description')
                    }
                }
            };
        },

        loadData: function () {
            const me = this;
            const metrics = me.dashboardModel.metrics;
            const collection = new RivalIQ.collections.MetricDefinitions(metrics);
            return collection.fetch()
                .done(function (collection) {
                    me.metrics = collection;
                });
        },

        onRenderLoaded: function () {
            const me = this;
            me.showChart();
        },

        getBarData: function () {
            const me = this;
            const metrics = me.metrics;
            const max = getMetricMax(metrics);
            return getBarData(metrics, max, function (metric) {
                return {
                    isMaximum: (metric.getValue({
                        format: false
                    }) === max)
                };
            });
        },

        showChart: function () {
            const me = this;

            const percentBars = new App.views.ProgressBars({
                inline: true,
                collection: new Backbone.Collection(me.getBarData())
            });

            me.chart.show(percentBars);
        },

        serializeData: function () {
            const me = this;
            return me.getProps();
        }
    });

    widgets.MetricProgressBarWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: widgets.MetricProgressBarView,
        processProps: function (props) {
            const me = this;

            me.metrics = _.map(props.metrics, function (metric) {
                return RivalIQ.metric.build(props, metric);
            });

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_PROGRESS_BAR, widgets.MetricProgressBarWidget);

});
